class FeatureListTabs extends HTMLElement {
  constructor() {
    super();

    this.tabTriggerElems = this.querySelectorAll('[data-tab-trigger]');
    this.tabContentElems = this.querySelectorAll('[data-tab-content]');
  }

  connectedCallback() {
    this.addTabListeners();
  }

  addTabListeners() {
    this.tabTriggerElems.forEach((triggerEl) => {
      triggerEl.addEventListener('click', (e) => {
        const tabId = triggerEl.getAttribute('data-tab-trigger');
        this.switchTab(tabId, triggerEl);
      });
    });
  }

  switchTab(tabId, clickedTriggerEl) {
    this.tabTriggerElems.forEach(triggerEl => {
      triggerEl.classList.remove('icon-list--item--active');
    });

    clickedTriggerEl.classList.add('icon-list--item--active');

    this.tabContentElems.forEach(contentEl => {
      contentEl.classList.remove('icon-list--mobile-tab-content--active');
    });

    const targetContent = this.querySelector(`[data-tab-content="${tabId}"]`);

    if (targetContent) targetContent.classList.add('icon-list--mobile-tab-content--active');
  }
}

if (!customElements.get('feature-list-tabs')) {
  customElements.define('feature-list-tabs', FeatureListTabs);
}
